<template>
   <div>
       <h1 style="padding: 20px;">{{ name }}'s Gallery - {{ images.length }} Images</h1>
        <lightbox v-if="this.images.length>0" :images="images" :name="this.name"></lightbox>
   </div>
</template>

<script>
    import lightbox from "../components/lightbox"

    import axios from 'axios'
    /* eslint no-console: 0 */


    export default {
        components: {
            lightbox
        },
        data: function() {
            return {
                images: [],
                id: '',
                name: ''
            }
        },
        watch: {},
        mounted: function() {
            if (this.$route.params.name) {
                this.name = this.$route.params.name;
                this.id = this.$route.params.id;
                if (!window.themodels || window.themodels.length==0) {
                    this.getModel();
                } else {
                    var tmp={};
                    tmp.data=window.themodels;
                    this.gotmodel(tmp);
                    window.themodels=[];
                }
            }
        },
        methods: {
            getModel: function() {
                console.log('getModel called');
                this.name = this.$route.params.name;
                this.id = this.$route.params.id;

                axios.get("https://cdn.gonewildreplay.com/cdn/getModel/" + this.name).then(this.gotmodel);
            },
            gotmodel: function(response) {
                console.log(response.data);
                var tmp = [];
                for (var key in response.data.Images) {
                    var m = {}
                    m.src = "https://cdn.gonewildreplay.com/cdn/full/" + response.data.Images[key].URL;
                    m.thumbnail = "https://cdn.gonewildreplay.com/cdn/thumb/" + response.data.Images[key].URL;
                    m.download = "https://cdn.gonewildreplay.com/cdn/downloadFile/" + response.data.Images[key].URL;
                    m.alt =  response.data.Images[key].Title;
                    tmp.push(m);
                }
                this.images = tmp;
            },
            hideme: function(i) {
                var tmp = [];
                for (var key in this.images) {
                    if (key != i) {
                        tmp.push(this.images[key])
                    }
                }
                this.images = tmp;

            }

        }
    }
</script>

<style>
</style>
